import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Icon from 'components/Icon'
import { getCurrencyIcon } from 'helpers/pricing'

import classes from './Currency.module.scss'

/** @type {import("./types").default} */
const Currency = ({ pricing, className, ...props }) => {
  const { hasSupportedIcon, currencyIcon } = getCurrencyIcon(pricing)

  return (
    <Grid className={clsx('Currency', classes.root, className)} {...props}>
      {hasSupportedIcon ? (
        <Icon icon={currencyIcon} size={24} className={classes.icon} />
      ) : (
        <span className={classes.specialCurrency} data-testid="currency">
          {currencyIcon}
        </span>
      )}
    </Grid>
  )
}

export default Currency
